export default __webpack_public_path__ + "static/media/PropertyDev_Button-02.da3b8713.png";